import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const ScheduledCstDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsScheduledCstDetails" */ 'modules/activityDetails/ScheduledCSTDetails/pages/ScheduledCstDetails'
    )
)

const ScheduledCstDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:scheduledCstId`} component={ScheduledCstDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default ScheduledCstDetailsRouting
